import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const VariantCardFooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing.base};
  width: 100%;
  padding-top: ${spacing.plusHalf};
`;

export const EditableVariantCardFooterWrapper = styled(VariantCardFooterWrapper)`
  button:first-child {
    margin-right: auto;
  }
`;
